import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import jaJP from './locales/ja-JP'
import enUS from './locales/en-US'

export type LocaleKey = 'zh-CN' | 'ja-JP' | 'en-US'

const defaultLocale = (import.meta.env.VITE_APP_DEFAULT_LANG || 'zh-CN') as LocaleKey

const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'ja-JP': jaJP,
    'en-US': enUS
  }
})

export default i18n
